const RELOADED_AT_KEY = 'staleBuildReloadedAt';
const RELOAD_COOLDOWN_MS = 10_000;
const MISSING_CHUNK_MESSAGE = /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Unable to preload CSS/i;

let reloading = false;

export function isMissingChunkError(error: unknown): boolean {
	return error instanceof Error && MISSING_CHUNK_MESSAGE.test(error.message);
}

export function canReloadForNewBuild(): boolean {
	if (reloading) {
		return true;
	}

	try {
		const reloadedAt = Number(sessionStorage.getItem(RELOADED_AT_KEY));
		return Date.now() - reloadedAt > RELOAD_COOLDOWN_MS;
	} catch {
		return false;
	}
}

export function reloadForNewBuild(): void {
	if (reloading) {
		return;
	}

	reloading = true;
	sessionStorage.setItem(RELOADED_AT_KEY, String(Date.now()));
	location.reload();
}
